// Lane-packing for the timeline. Earliest-fit: each job slots into the
// first lane whose tail ended before this job starts.
// Conflict = two ACTIVE-status jobs that strictly overlap.

import { ACTIVE_ERP_STATUSES } from "./status.map";

const intervalsOverlap = (a, b) => a.start < b.end && b.start < a.end;

export const packLanes = jobs => {
  if (!Array.isArray(jobs) || jobs.length === 0) {
    return { lanes: [], conflictIds: new Set() };
  }
  const sorted = [...jobs].sort((a, b) => a.start - b.start);
  const lanes = [];
  for (const job of sorted) {
    let placed = false;
    for (const lane of lanes) {
      if (lane[lane.length - 1].end <= job.start) {
        lane.push(job);
        placed = true;
        break;
      }
    }
    if (!placed) lanes.push([job]);
  }

  // Conflict pass — only flag overlapping ACTIVE jobs.
  const conflictIds = new Set();
  const active = sorted.filter(j => ACTIVE_ERP_STATUSES.includes(j.status));
  for (let i = 0; i < active.length; i++) {
    for (let j = i + 1; j < active.length; j++) {
      if (intervalsOverlap(active[i], active[j])) {
        conflictIds.add(active[i].id);
        conflictIds.add(active[j].id);
      }
    }
  }
  return { lanes, conflictIds };
};
